import { useEffect, useState } from 'react'
import { Package, RefreshCw, CheckCircle, XCircle } from 'lucide-react'

interface BatchData {
  totalBatches: number
  processedBatches: number
  pendingBatches: number
  recentBatches: Array<{
    id: string
    name: string
    status: string
    items: number
    date: string
  }>
}

export default function BatchPage() {
  const [data, setData] = useState<BatchData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchBatchData()
  }, [])

  const fetchBatchData = async () => {
    setLoading(true)
    // TODO: Implementar chamada real à API do Batch
    setTimeout(() => {
      setData({
        totalBatches: 0,
        processedBatches: 0,
        pendingBatches: 0,
        recentBatches: []
      })
      setLoading(false)
    }, 1000)
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Batch</h1>
          <p className="text-gray-600 mt-1">Gestão de lotes e processamento em massa</p>
        </div>
        <button
          onClick={fetchBatchData}
          className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition"
        >
          <RefreshCw className="w-4 h-4" />
          Atualizar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total de Lotes</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.totalBatches || 0}</p>
            </div>
            <Package className="w-8 h-8 text-purple-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Processados</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.processedBatches || 0}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Pendentes</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.pendingBatches || 0}</p>
            </div>
            <XCircle className="w-8 h-8 text-yellow-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Lotes Recentes</h2>
        </div>
        <div className="p-6">
          {data?.recentBatches.length === 0 ? (
            <p className="text-gray-500 text-center py-8">Nenhum lote encontrado</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-left text-gray-600 border-b">
                    <th className="pb-3">ID</th>
                    <th className="pb-3">Nome</th>
                    <th className="pb-3">Itens</th>
                    <th className="pb-3">Status</th>
                    <th className="pb-3">Data</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.recentBatches.map((batch) => (
                    <tr key={batch.id} className="border-b">
                      <td className="py-3">{batch.id}</td>
                      <td className="py-3">{batch.name}</td>
                      <td className="py-3">{batch.items}</td>
                      <td className="py-3">
                        <span className={`px-2 py-1 rounded text-sm ${
                          batch.status === 'Processado' 
                            ? 'bg-gray-100 text-black' 
                            : 'bg-gray-100 text-black'
                        }`}>
                          {batch.status}
                        </span>
                      </td>
                      <td className="py-3">{batch.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
